// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "path[data-v-2c8e4bd6] {\n  fill: currentColor;\n}", ""]);
// Exports
module.exports = exports;
